import styled from 'styled-components/macro';
import { Box, Button, COLORS } from '@podiumhq/design-system';

import { InputErrorMessage } from '../../styles';

const blue = COLORS.blue.base;
const errorRed = COLORS.red.dark;
const placeholderText = COLORS.grey.lighter;
const silver = COLORS.silver.base;
const textColor = COLORS.black.lighter;
const white = COLORS.silver.lightest;

export const FORM_COLORS = {
  blue,
  errorRed,
  placeholderText,
  silver,
  textColor,
  white,
};

export const FormElementsInputWrapper = styled(Box)`
  margin-bottom: 24px;

  .StripeElement {
    background-color: ${COLORS.silver.lighter};
    border: 1px solid ${({ error }) => (error ? errorRed : silver)};
    border-radius: 8px;
    box-sizing: border-box;
    color: ${textColor};
    height: 48px;
    line-height: 48px;
    padding: 4px 16px;
    width: 100%;
  }

  .StripeElement--error {
    border: 1px solid ${errorRed};
    box-shadow: none;
  }

  .StripeElement--focus {
    background: ${white};
    border: 1px solid ${blue};
    box-shadow: 0 0 0 2px rgba(76, 118, 224, 0.25);
  }

  .StripeElement--invalid {
    border: 1px solid ${errorRed};
    box-shadow: none;
  }

  ${({ error, id }) =>
    !!error &&
    `
    input[id=${id}] {
      padding-right: 30px;
    }

    input[id=${id}],
    .StripeElement {
      border-color: ${errorRed};
    }

    select[id=${id}] {
      padding-right: 40px;
    }

    .chakra-select__icon-wrapper {
      right: 30px
    }
  `};
`;

export const FormElementsInputErrorMessage = styled(InputErrorMessage)`
  margin-top: 8px;
`;

export const FormElementsButton = styled(Button)`
  border: none;
`;
